/**
 * Route for `enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyPage } from "../features/enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency/EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyPage";

export const enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency",
	component: EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyPage,
});

export default enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRoute;
